module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Row', {
    staticClass: "padding-blank"
  }, [_c('h3', {
    staticClass: "all-title"
  }, [_vm._v("需求列表"), _c('Button', {
    staticClass: "float-right",
    attrs: {
      "type": "success",
      "icon": "android-add"
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Table', {
    attrs: {
      "data": _vm.tableData1,
      "columns": _vm.tableColumns1,
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": 100,
      "current": 1
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c676c9c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/requirement/components/List.vue
// module id = 18
// module chunks = 0